<script lang="ts">
  import type { CampaignBanner as Banner } from "$lib/types/shared";
  import { PortableText } from "@portabletext/svelte";
  import { contentBlockComponents } from "$lib/portableText/utils";

  

  interface Props {
    campaignBanner: Banner;
    class?: string;
  }

  let { campaignBanner, class: classes = "" }: Props = $props();
</script>

{#if campaignBanner.confettiActive}
  {#await import("./Confetti.svelte") then Module}
    <Module.default />
  {/await}
{/if}

<div class="banner bg-$reinlav px-4 laptop:px-8 py-1 mb-6 rounded-2xl {classes}">
  <p>
    <strong class="block heading-3 mb-2">{campaignBanner.title}</strong>
  </p>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  <PortableText value={campaignBanner.content} components={contentBlockComponents} />
</div>

<style lang="postcss">
  @media (prefers-reduced-motion: reduce) {
    .confetti-container {
      display: none;
    }
  }
</style>
